import React from 'react'
import './loader.scss'

const Loader = (props) => {
    return (
        <div className={`${props.dark ? 'huntplanner-load-spinner dark-background' : 'huntplanner-load-spinner'}`} style={{ position: props.position ? props.position : '', left: props.left ? props.left : '' }}>
            <div className="loader-spinner" style={{ width: props.width ? props.width : '' }}></div>
        </div>
    )
}

export default Loader
